var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "px-1 sm:px-12 py-8 font-outfit flex-1" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center mb-4 pb-4 borderMainClientProfile",
      },
      [
        _c("h2", { staticClass: "text-lg font-normal" }, [
          _vm._v("Care Goals"),
        ]),
        _c(
          "button",
          {
            staticClass:
              "px-8 py-2 text-16 rounded-full border border-secondary-black hover:bg-gray-50 focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(" Edit ")]
        ),
      ]
    ),
    _c("div", { staticClass: "flex flex-col gap-5" }, [
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Short Term"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.short_term_goals ? _vm.data.short_term_goals : "N/A"
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Long Term"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(_vm.data.long_term_goals ? _vm.data.long_term_goals : "N/A")
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Special Care Needs"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.specific_care_needs
                ? _vm.data.specific_care_needs
                : "N/A"
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Outcomes"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.desired_outcomes ? _vm.data.desired_outcomes : "N/A"
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "flex gap-8" }, [
        _c("div", { staticClass: "flex-1 text-16 font-medium minWContent" }, [
          _vm._v("Self Directed Care"),
        ]),
        _c("div", { staticClass: "flex-2 text-16 font-medium text-gray-400" }, [
          _vm._v(
            _vm._s(
              _vm.data.self_directed_care_preferences
                ? _vm.data.self_directed_care_preferences
                : "N/A"
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }